/*
 * @Author: mql_pcthree@163.com tan13872711312@163.com
 * @Date: 2022-07-02 16:02:34
 * @LastEditors: mql_pcthree@163.com tan13872711312@163.com
 * @LastEditTime: 2022-07-05 08:15:50
 * @FilePath: \mei_qi_zeroweb_endlyq\src\store\modules\bll\member.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { lakalaPayConfig } from '../../../api/goods'
// import * as TYPE from './mutations-type'

const state = {
  serialNumber: ''
}

const getters = {}
const mutations = {
  upSerialNumber(state, dom) {
    state.serialNumber = dom
  }
}
const actions = {
  async getLaKaLaInfo({ commit }, tenantId) {
    const result = await lakalaPayConfig(tenantId)
    if (result.data[0] ? result.data[0].id : false) {
      window.localStorage.setItem('lakal', result.data[0].id)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bll/index.js